import type { StudentCard } from "@/app/reviewQueries";
import { facts, flagChips } from "./model";

const TONE = { ink2: "text-ink2", warn: "text-warn", mut: "text-mut" } as const;

export function FlagChips({ card, now }: { card: StudentCard; now: number }) {
  const chips = flagChips(card, now);
  if (chips.length === 0) return null;
  return (
    <div className="flex flex-wrap gap-1.5" data-testid="flag-chips">
      {chips.map((c) => (
        <span key={c.label} className={`rounded-sm border px-2 py-[3px] font-mono text-[11px] ${c.tone === "err" ? "border-err bg-errsoft text-err" : "border-warn bg-warnsoft text-warn"}`}>
          {c.label}
        </span>
      ))}
    </div>
  );
}

/** «Сводка» — все цифры из карточки. */
export function Summary({ card }: { card: StudentCard }) {
  return (
    <section className="rounded-lg border border-bd bg-card px-4 py-3.5" data-testid="summary">
      <div className="mb-1.5 font-mono text-[10.5px] uppercase tracking-[.06em] text-mut">сводка</div>
      {facts(card).map((f) => (
        <div key={f.k} className="flex items-baseline justify-between gap-3 border-b border-bd py-[7px] font-mono text-[12px] last:border-0">
          <span className="text-mut">{f.k}</span>
          <span className={TONE[f.tone ?? "ink2"]}>{f.v}</span>
        </div>
      ))}
    </section>
  );
}

/** Маршрут и гейты глазами ментора — API появится в SP5; место сохранено по макету. */
export function RouteSoon() {
  return (
    <section className="rounded-lg border border-dashed border-bd px-4 py-3.5" data-testid="route-soon">
      <div className="mb-1.5 font-mono text-[10.5px] uppercase tracking-[.06em] text-mut">маршрут и гейты</div>
      <p className="m-0 text-[12.5px] leading-[1.5] text-ink2">Маршрут студента и его гейты — в SP5 вместе с аналитикой. Пока ориентир — сдачи: по заданию видно шаг, на котором он стоит.</p>
    </section>
  );
}
